module.exports = __webpack_public_path__ + "brand-icons.579cad8471395197d60c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brand-icons/brand-icons.eot
// module id = 687
// module chunks = 3